import Swiper, { Keyboard, A11y, Lazy, Navigation, Autoplay } from 'swiper/swiper.esm';
import play from './images/svg/play-button.svg';
import pause from './images/svg/pause-button.svg';

const slideSpeed = 500;
const defaultConfig = {
  modules: [Keyboard, A11y, Lazy, Navigation, Autoplay],
  direction: 'horizontal',
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  grabCursor: false,
  init: false,
  lazy: true,
  a11y: true,
  keyboard: {
    enabled: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  preventInteractionOnTransition: true,
  slidesPerView: 'auto',
  slideToClickedSlide: true,
  speed: slideSpeed,
  watchOverflow: true,
};

const toggleAutoPlayClasses = slider => {
  slider.el.classList.toggle('swiper-is-paused');
  slider.el.classList.toggle('swiper-is-playing');
};

export const init = (context = document) => {
  const sliders = context.querySelectorAll('[data-slider]');
  if (!sliders) return;

  const startSlider = slider => {
    const statementSlider = slider.closest('.statement-slider__slider');
    if (statementSlider) {
      defaultConfig.autoplay.delay = 6000;
    }

    const config = { ...defaultConfig, ...JSON.parse(slider.getAttribute('data-slider')) };
    const swiper = new Swiper(slider, config);

    swiper.on('init', () => {
      swiper.el.classList.add('swiper-is-playing');
      const bullets = swiper.el.querySelector('.swiper-play-pause-container');

      const playButton = document.createElement('span');
      playButton.classList.add('swiper-play-button');
      playButton.appendChild(play());
      playButton.style.cursor = 'pointer';
      playButton.setAttribute('tabindex', 0);
      playButton.setAttribute('role', 'button');
      playButton.setAttribute('aria-label', 'Play');
      bullets.appendChild(playButton);
      bullets.querySelector('.swiper-play-button').addEventListener(
        'click',
        // eslint-disable-next-line func-names
        function() {
          swiper.autoplay.start();
          toggleAutoPlayClasses(swiper);
        },
        false
      );

      bullets.querySelector('.swiper-play-button').addEventListener(
        'keydown',
        // eslint-disable-next-line func-names
        function(e) {
          const isEnterPressed = e.key === 'Enter' || e.keyCode === 13;
          if (isEnterPressed) {
            swiper.autoplay.start();
            toggleAutoPlayClasses(swiper);
          }
        },
        false
      );

      const pauseButton = document.createElement('span');
      pauseButton.classList.add('swiper-pause-button');
      pauseButton.appendChild(pause());
      pauseButton.style.cursor = 'pointer';
      pauseButton.setAttribute('tabindex', 0);
      pauseButton.setAttribute('role', 'button');
      pauseButton.setAttribute('aria-label', 'Pause');
      bullets.appendChild(pauseButton);
      bullets.querySelector('.swiper-pause-button').addEventListener(
        'click',
        // eslint-disable-next-line func-names
        function() {
          swiper.autoplay.stop();
          toggleAutoPlayClasses(swiper);
        },
        false
      );

      bullets.querySelector('.swiper-pause-button').addEventListener(
        'keydown',
        // eslint-disable-next-line func-names
        function(e) {
          const isEnterPressed = e.key === 'Enter' || e.keyCode === 13;
          if (isEnterPressed) {
            swiper.autoplay.stop();
            toggleAutoPlayClasses(swiper);
          }
        },
        false
      );
    });

    swiper.on('slideChange', () => {
      if (!swiper.el.classList.contains('swiper-is-playing')) {
        swiper.el.classList.add('swiper-is-playing');
        swiper.el.classList.remove('swiper-is-paused');
        swiper.autoplay.start();
      }
    });

    swiper.init();
  };

  [...sliders].forEach(slider => {
    startSlider(slider);
  });
};
